import moment from 'moment';
import { minValidDate } from '../../DataEntry/Grid/gridFunctions';
import { DASHBOARD, DATA_ENTRY, NEW_DATA_ENTRY, NEW_EDIT_WORK, NEW_QA_REVIEW } from '../../../../routeNames.js';
import { validateLiteClaim, validateLiteServiceLine } from '../schemas/validationSchema835Lte';
import { validateCorresClaim } from '../schemas/validationSchemaCorres';
// import { saveIndexedData } from '../../DataEntry/indexedDB';
// import { changeAllTitleFunction } from '../../Dashboard/functions';
import Swal from 'sweetalert2';
import { patterns } from '../constants';
import { filterAndRemoveKeys, hasQaError } from './index1';
import { getValidatecARCaNDrARC } from '../../../../redux/grid/action.js';

export const handleAddPlbAdjustment = (getValues, setValue, handlePlbPaginatedCurrentPage) => {
  const data = structuredClone(getValues('plb_adjustments')) || [];
  handlePlbPaginatedCurrentPage(true, data.length);

  const plb_order = Math.max(...data.map(i => i.order || 0), 0) + 1;

  const newAdjustment = {
    order: plb_order,
    plb_adjustment_id: '',
    corrected_plb: true,
    npi: '',
    plb_page: '1',
    reason: 0,
    patient_account_number: '',
    plb_amt: '',
  };

  setValue('plb_adjustments', [...data, newAdjustment], { shouldValidate: true });
};

export const removeClaimEntity = (claims, index, type) => {
  const updatedClaims = claims.map((claim, ind) => {
    if (ind !== index) return claim;

    const fieldsMap = {
      patient: [
        'patient_id',
        'patient_first_name',
        'patient_middle_name',
        'patient_last_name',
        'patient_identifier_code',
      ],
      subscriber: [
        'subscriber_id',
        'subscriber_first_name',
        'subscriber_middle_name',
        'subscriber_last_name',
        'subscriber_identifier_code',
      ],
      rendering_provider: [
        'rendering_provider_id',
        'rendering_provider_first_name',
        'rendering_provider_last_name',
        'rendering_provider_identifier_code',
      ]
    };

    const cleared = { ...claim, [type]: false };
    fieldsMap[type].forEach((field) => {
      if (cleared[field] && typeof cleared[field] === 'object' && 'val' in cleared[field]) {
        cleared[field] = '';
      } else {
        cleared[field] = '';
      }
    });
    return cleared;
  });

  return updatedClaims;
};

export const updateFormValues = (setValue, currentValues, updates) => {
    // Batch update multiple form fields
    Object.entries(updates).forEach(([key, value]) => {
        setValue(key, value);
    });
};
export function getNestedValue(obj, path) {
    if (!obj || !path) return undefined;
    
    // normalize brackets to dot notation
    const normalized = path.replace(/\.?\[(\d+)\]/g, ".$1");
    const parts = normalized.split(".");

    return parts.reduce((acc, part) => {
      if (acc === undefined || acc === null) return undefined;
      return /^\d+$/.test(part) ? acc[Number(part)] : acc[part];
    }, obj);
  }
  
  
function parseOrZero(value) {
    if (value === "" || value === undefined || value === null) {
        return "";
    }

    if (typeof value === "number") {
        return isNaN(value) ? 0 : value;
    }

    if (typeof value === "string") {
        const dotCount = (value.match(/\./g) || []).length;
        if (dotCount > 1) return 0;

        const parsed = parseFloat(value);
        return isNaN(parsed) ? 0 : parsed;
    }

    return 0;
}

function toFixedOrEmpty(value) {
    if (value === "" || value === undefined || value === null) {
        return "";
    }
    if (typeof value === "number") {
        return isNaN(value) ? "" : value.toFixed(2);
    }
    if (typeof value === "string") {
        const parsed = parseFloat(value);
        return isNaN(parsed) ? "" : parsed.toFixed(2);
    }
    return "";
}

export const gridNewCalculate = (claim,qdxTransaction) => {
        const isServiceLineExist = claim?.service_lines?.length||0
        const isQdxPatientPay = qdxTransaction === "PATIENT_PAY_835"
        let total = 0;
        let fake_patres = 0;
        let adjustment_total = 0;

        let sl_billed = 0
        let sl_paid = 0
        let sl_discount = 0;
        let sl_allowed = 0
        let sl_deduct = 0
        let sl_coins = 0
        let sl_copay = 0
        let sl_cob = 0
        let sl_balance = 0
        let sl_amount = 0
        let sl_patres = 0
        if (!Array.isArray(claim?.service_lines)) {
            return {
                ...claim,
                sl_discount: 0,
                sl_allowed: 0,
                sl_deduct: 0,
                sl_coins: 0,
                sl_copay: 0,
                sl_cob: 0,
                sl_paid: 0,
                sl_amount: 0,
                sl_balance: 0,
                sl_billed: 0,
                sl_patres: 0,
                claim_billed: 0,
                claim_discount: 0,
                claim_allowed: 0,
                claim_deduct: 0,
                claim_coins: 0,
                claim_copay: 0,
                claim_cob: 0,
                claim_paid: 0,
                claim_balance: 0,
                claim_patres: 0,
            }
        }
        const updatedServiceLines = claim?.service_lines?.map((serviceLine) => {
            let amount_total = 0;
        
            let final_dict = { 
                ...serviceLine,
                sl_discount : isQdxPatientPay?0.00:parseOrZero(serviceLine?.sl_discount),
                sl_allowed : isQdxPatientPay?0.00:parseOrZero(serviceLine?.sl_allowed),
                sl_deduct : isQdxPatientPay?0.00:parseOrZero(serviceLine?.sl_deduct),
                sl_coins : isQdxPatientPay?0.00:parseOrZero(serviceLine?.sl_coins),
                sl_copay : isQdxPatientPay?0.00:parseOrZero(serviceLine?.sl_copay),
                sl_cob : isQdxPatientPay?0.00:parseOrZero(serviceLine?.sl_cob),
                sl_amount : isQdxPatientPay?0.00:parseOrZero(serviceLine?.sl_amount),
                sl_billed : parseOrZero(serviceLine?.sl_billed),
                sl_paid : parseOrZero(serviceLine?.sl_paid),
                discount : isQdxPatientPay?0.00:parseOrZero(serviceLine?.discount),
                allowed : isQdxPatientPay?0.00:parseOrZero(serviceLine?.allowed),
                deduct : isQdxPatientPay?0.00:parseOrZero(serviceLine?.deduct),
                coins : isQdxPatientPay?0.00:parseOrZero(serviceLine?.coins),
                copay : isQdxPatientPay?0.00:parseOrZero(serviceLine?.copay),
                cob : isQdxPatientPay?0.00:parseOrZero(serviceLine?.cob),
                amount : isQdxPatientPay?0.00:parseOrZero(serviceLine?.amount),
                adjustments:isQdxPatientPay?[]:serviceLine?.adjustments||[],
                billed : parseOrZero(serviceLine?.billed),
                paid : parseOrZero(serviceLine?.paid),
             };
            // Helper functions for clean calculations
            function safeParse(value) {
                return parseFloat(value) || 0; // Convert to number, default to 0 if NaN
            }
        
            function safeAdd(...values) {
                return values.reduce((acc, val) => acc + safeParse(val), 0).toFixed(2);
            }
        
            // Calculate `amount_total` from adjustments
            amount_total = final_dict?.adjustments?.reduce((sum, adj) => sum + safeParse(adj?.amount), 0) || 0;
        
            // Clone adjustments for current amount calculation
            let current_amount = final_dict?.adjustments ? structuredClone(final_dict.adjustments).reduce((sum, item) => sum + safeParse(item?.amount), 0) : 0;
        
        
            // Summing up service line values safely
            sl_billed = safeAdd(sl_billed, final_dict?.billed);
            sl_discount = safeAdd(sl_discount, final_dict?.discount);
            sl_allowed = safeAdd(sl_allowed, final_dict?.allowed);
            sl_deduct = safeAdd(sl_deduct, final_dict?.deduct);
            sl_coins = safeAdd(sl_coins, final_dict?.coins);
            sl_copay = safeAdd(sl_copay, final_dict?.copay);
            sl_cob = safeAdd(sl_cob, final_dict?.cob);
            sl_paid = safeAdd(sl_paid, final_dict?.paid);
            sl_amount = safeAdd(sl_amount, current_amount);
        
            // Calculate `total_balance`
            const total_balance =
                safeParse(final_dict?.billed) -
                safeParse(final_dict?.discount) -
                safeParse(final_dict?.deduct) -
                safeParse(final_dict?.coins) -
                safeParse(final_dict?.copay) -
                safeParse(final_dict?.cob) -
                safeParse(final_dict?.paid) -
                safeParse(amount_total);
        
            // ================== PATRES ==================
            let total = safeAdd(
                total,
                final_dict?.deduct,
                final_dict?.coins,
                final_dict?.copay
            );
        
            final_dict?.adjustments?.forEach((adjustment) => {
                if (adjustment?.group_code === 'PR') {
                    total = safeAdd(total, adjustment?.amount);
                }
            });
        
            // Calculate `adjustment_total`
            adjustment_total = final_dict?.adjustments?.reduce((sum, adj) => sum + safeParse(adj?.amount), 0) || 0;
        
            // Calculate `fake_patres`
             fake_patres = safeAdd(
                fake_patres,
                final_dict?.deduct,
                final_dict?.coins,
                final_dict?.copay,
            );
        
            final_dict?.adjustments?.forEach((adjustment) => {
                if (adjustment?.group_code === 'PR') {
                    fake_patres = safeAdd(fake_patres, adjustment?.amount);
                }
            });
        
            // Update `sl_balance`
            sl_balance = safeAdd(sl_balance, total_balance);
        
            // Convert `total_balance` to formatted balance value
            const currentBalance = (parseFloat(total_balance.toFixed(2)) + 0).toFixed(2);
        
            return { ...final_dict,
                discount : toFixedOrEmpty(final_dict?.discount),
                allowed : toFixedOrEmpty(final_dict?.allowed),
                deduct : toFixedOrEmpty(final_dict?.deduct),
                coins : toFixedOrEmpty(final_dict?.coins),
                copay : toFixedOrEmpty(final_dict?.copay),
                cob : toFixedOrEmpty(final_dict?.cob),
                amount : toFixedOrEmpty(final_dict?.amount),
                billed : toFixedOrEmpty(final_dict?.billed),
                paid : toFixedOrEmpty(final_dict?.paid),
                balance: currentBalance 
            };
        });
        sl_patres = fake_patres ?? 0 
        // CLAIM PATRESS
        claim?.claim_adjustments?.forEach((adjustment, ind) => {
            if (adjustment?.group_code == 'PR') {
                fake_patres =
                    parseFloat(fake_patres ? fake_patres : 0) +
                    parseFloat(adjustment?.amount ? adjustment?.amount : 0);
            }
        });


        let sl_total_diff = 0;
        let claim_total_diff = 0;
        let diff = 0;
        const _ = require('lodash');
        sl_total_diff = parseFloat(sl_total_diff ? sl_total_diff : 0) +
            parseFloat(sl_deduct ? sl_deduct : 0) +
            parseFloat(sl_coins ? sl_coins : 0) +
            parseFloat(sl_copay ? sl_copay : 0);


        claim_total_diff = parseFloat(claim_total_diff ? claim_total_diff : 0) +
            parseFloat(sl_deduct ? sl_deduct : 0) +
            parseFloat(sl_coins ? sl_coins : 0) +
            parseFloat(sl_copay ? sl_copay : 0);


        if (Math.abs(parseFloat(sl_total_diff).toFixed(2) - parseFloat(claim_total_diff).toFixed(2)) != parseFloat(0).toFixed(2)) {
            diff = Math.abs(parseFloat(sl_total_diff).toFixed(2) - parseFloat(claim_total_diff).toFixed(2))

        }
        fake_patres = parseFloat(fake_patres ? fake_patres : 0) + parseFloat(diff ? diff : 0);
        claim.adjustment_total = parseFloat(adjustment_total).toFixed(2);
        claim.sl_patres = parseFloat(total).toFixed(2);
        claim.fake_sl_patres = parseFloat(fake_patres).toFixed(2);
        claim.claim_patres = parseFloat(fake_patres).toFixed(2);

        let cl_amount_total = 0;
        let cl_amount_total_pr = 0;
        claim.claim_adjustments?.map((adjustment, ind) => {
            cl_amount_total = parseFloat(cl_amount_total ? cl_amount_total : 0) + parseFloat(adjustment?.amount ? adjustment?.amount : 0);
            cl_amount_total_pr += adjustment?.group_code === "PR"? parseFloat(adjustment?.amount ? adjustment?.amount : 0):0;
        });
        const claim_balance =
            parseFloat(parseFloat(sl_billed ? sl_billed : 0) -
                parseFloat(sl_discount ? sl_discount : 0) -
                parseFloat(sl_deduct ? sl_deduct : 0) -
                parseFloat(sl_coins ? sl_coins : 0) -
                parseFloat(sl_copay ? sl_copay : 0) -
                parseFloat(sl_cob ? sl_cob : 0) -
                parseFloat(sl_paid ? sl_paid : 0) -
                parseFloat(cl_amount_total ? cl_amount_total : 0) -
                parseFloat(sl_amount ? sl_amount : 0)).toFixed(2)
        const sl_balance2 =
            parseFloat(parseFloat(sl_billed ? sl_billed : 0) -
                parseFloat(sl_discount ? sl_discount : 0) -
                parseFloat(sl_deduct ? sl_deduct : 0) -
                parseFloat(sl_coins ? sl_coins : 0) -
                parseFloat(sl_copay ? sl_copay : 0) -
                parseFloat(sl_cob ? sl_cob : 0) -
                parseFloat(sl_paid ? sl_paid : 0) -
                parseFloat(sl_amount ? sl_amount : 0)).toFixed(2)
                
        return {
            ...claim,
            sl_discount: sl_discount,
            sl_allowed: sl_allowed,
            sl_deduct: sl_deduct,
            sl_coins: sl_coins,
            sl_copay: sl_copay,
            sl_cob: sl_cob,
            sl_paid: sl_paid,
            sl_amount: sl_amount,
            sl_balance: sl_balance2,
            sl_billed:sl_billed,
            sl_patres:sl_patres,
            claim_adjustment_total:cl_amount_total,
            claim_adjustment_total_pr:cl_amount_total_pr,
            claim_billed: isServiceLineExist===0? parseOrZero(claim?.claim_billed): sl_billed,
            claim_discount: isServiceLineExist===0? parseOrZero(claim?.claim_discount):sl_discount,
            claim_allowed: isServiceLineExist===0? parseOrZero(claim?.claim_allowed):sl_allowed,
            claim_deduct: isServiceLineExist===0? parseOrZero(claim?.claim_deduct):sl_deduct,
            claim_coins: isServiceLineExist===0? parseOrZero(claim?.claim_coins):sl_coins,
            claim_copay: isServiceLineExist===0? parseOrZero(claim?.claim_copay):sl_copay,
            claim_cob: isServiceLineExist===0? parseOrZero(claim?.claim_cob):sl_cob,
            claim_paid: isServiceLineExist===0? parseOrZero(claim?.claim_paid):sl_paid,
            claim_balance: isServiceLineExist===0? parseOrZero(claim?.claim_balance):claim_balance,
            service_lines: updatedServiceLines,


        };
    }

// src/utils/patientPayCalculateClaim.js

export const patientPayCalculateClaim = (claim = {}) => {
  const {
    claim_discount,
    claim_allowed,
    claim_deduct,
    claim_coins,
    claim_copay,
    claim_cob,
    claim_patres,
    sl_discount,
    sl_allowed,
    sl_deduct,
    sl_coins,
    sl_copay,
    sl_cob,
    sl_patres,
    sl_total,
    sl_amount,
    adjustment_total,
    prior_auth_code,
    rendering_provider,
    ...rest
  } = claim;
  
  return rest;
};

// ==================QDX CORRES GRAY OR DISABLE START==================
// Field arrays - moved outside to prevent recreation
const FIELD_CATEGORIES = {
  pulled837: new Set([
    'check_page_number', 'discount', 'mrn', 'statement_number', 'allowed', 
    'deduct', 'coins', 'copay', 'cob', 'claim_discount', 'claim_allowed', 
    'claim_deduct', 'claim_coins', 'claim_copay', 'claim_cob'
  ]),
  
  notPulled837: new Set([
    'check_page_number', 'payer_claim_number', 'mrn', 'statement_number', 
    'patient_middle_name', 'subscriber_first_name', 'subscriber_middle_name', 
    'subscriber_last_name', 'subscriber_identifier_code', 'rendering_provider_first_name', 
    'rendering_provider_last_name', 'rendering_provider_identifier_code', 'code', 
    'procedure_type', 'modifier1', 'modifier2', 'modifier3', 'modifier4', 'rev_code', 
    'units', 'pc', 'group_code', 'rmk', 'reason_code', 'discount', 'allowed', 
    'deduct', 'coins', 'copay', 'cob', 'claim_discount', 'claim_allowed', 
    'claim_deduct', 'claim_coins', 'claim_copay', 'claim_cob', 'claim_pc', 
    'claim_group_code', 'claim_reason_code', 'claim_rmk'
  ]),
  
  anyPulled: new Set([
    'payer_address', 'payer_city', 'payer_state', 'payer_zip', 
    'payee_address', 'payee_city', 'payee_state', 'payee_zip'
  ])
};

// Cache for localStorage to avoid repeated reads
let is837PulledCache = null;
const getIs837Pulled = () => {
  if (is837PulledCache === null||is837PulledCache===false) {
    is837PulledCache = localStorage.getItem('837_pulled') === 'true';
  }
  return is837PulledCache;
};

// Reset cache function (call this when 837_pulled status changes)
export const resetIs837PulledCache = () => {
  is837PulledCache = null;
};

// Main optimized function - NORMAL FUNCTION (RECOMMENDED)
export const grayOrdisableCorresField = (field, claim, jobData, qdxTransaction) => {
    // Early return for nextgen_z_code condition
  if (jobData?.client_level_customization?.is_enable_nextgen_z_code) {
    return false;
  }
  // Early return for non-CORRESPONDENCE transactions
  if (qdxTransaction !== "CORRESPONDENCE_835") {
    return false;
  }
  
  // Check if claim has encounter
  const hasEncounter = claim?.encounter && claim.encounter !== '';
  
  if (hasEncounter) {
    // If claim has encounter, disable only pulled837 fields
    return FIELD_CATEGORIES.pulled837.has(field);
  }
  
  // If claim has no encounter
  if (FIELD_CATEGORIES.notPulled837.has(field)) {
    return true;
  }
  
  if (FIELD_CATEGORIES.anyPulled.has(field)) {
    // Return opposite of is837Pulled (disable if not pulled)
    return !getIs837Pulled();
  }
  
  return false;
};
// ==================QDX CORRES GRAY OR DISABLE END==================

export const parseRegisterFieldInfo = (fullName) => {
  try {
    if (!fullName) {
      return { 
        fieldName: "", 
        claimIndex: null, 
        serviceLineIndex: null, 
        serviceLineAdjIndex: null, 
        claimAdjIndex: null 
      };
    }

    // Normalize array notation to dot notation
    const normalized = fullName.replace(/\.?\[(\d+)\]/g, ".$1");
    const parts = normalized.split(".");
    let claimIndex = null;
    let plbIndex = null;
    let serviceLineIndex = null;
    let serviceLineAdjIndex = null;
    let claimAdjIndex = null;

    // Extract claim index
    if (parts[0] === "claims" && !isNaN(parts[1])) {
      claimIndex = parseInt(parts[1], 10);
    }

    // Extract service line index
    const plbPos = parts.indexOf("plb_adjustments");
    if (plbPos !== -1 && plbPos + 1 < parts.length && !isNaN(parts[plbPos + 1])) {
      plbIndex = parseInt(parts[plbPos + 1], 10);
    }
    // Extract service line index
    const serviceLinePos = parts.indexOf("service_lines");
    if (serviceLinePos !== -1 && serviceLinePos + 1 < parts.length && !isNaN(parts[serviceLinePos + 1])) {
      serviceLineIndex = parseInt(parts[serviceLinePos + 1], 10);
    }

    // Extract service line adjustment index
    const adjustmentsPos = parts.indexOf("adjustments");
    if (adjustmentsPos !== -1 && adjustmentsPos + 1 < parts.length && !isNaN(parts[adjustmentsPos + 1])) {
      // Check if this is under service_lines
      const isServiceLineAdj = parts.slice(0, adjustmentsPos).includes("service_lines");
      if (isServiceLineAdj) {
        serviceLineAdjIndex = parseInt(parts[adjustmentsPos + 1], 10);
      }
    }

    // Extract claim adjustment index
    const claimAdjPos = parts.indexOf("claim_adjustments");
    if (claimAdjPos !== -1 && claimAdjPos + 1 < parts.length && !isNaN(parts[claimAdjPos + 1])) {
      claimAdjIndex = parseInt(parts[claimAdjPos + 1], 10);
    }

    // Get the field name (last part)
    const fieldName = parts[parts.length - 1];

    return {
      fieldName,
      claimIndex,
      serviceLineIndex,
      serviceLineAdjIndex,
      claimAdjIndex,
      plbIndex
    };

  } catch (error) {
    // Return default safe values on error
    return {
      fieldName: "",
      claimIndex: null,
      serviceLineIndex: null,
      serviceLineAdjIndex: null,
      claimAdjIndex: null
    };
  }
};

// Parse complete path info to determine entity type and indices
export const parseFullPathInfo = (fullName) => {
  try {
    if (!fullName) return { entityType: null, entityPath: null, fieldName: null };
    const normalized = fullName.replace(/\[(\d+)\]/g, '.$1');
    const parts = normalized.split('.');

    let entityType = null;
    let entityPath = null;
    let claimIndex = null;
    let serviceLineIndex = null;
    let adjustmentIndex = null;
    let claimAdjustmentIndex = null;
    let plbIndex = null;

    const fieldName = parts[parts.length - 1];
    for (let i = 0; i < parts.length; i++) {
      if (parts[i] === 'claims' && !isNaN(parts[i + 1])) {
        claimIndex = parseInt(parts[i + 1], 10);
      }
      if (parts[i] === 'service_lines' && !isNaN(parts[i + 1])) {
        serviceLineIndex = parseInt(parts[i + 1], 10);
      }
      if (parts[i] === 'adjustments' && !isNaN(parts[i + 1])) {
        adjustmentIndex = parseInt(parts[i + 1], 10);
      }
      if (parts[i] === 'claim_adjustments' && !isNaN(parts[i + 1])) {
        claimAdjustmentIndex = parseInt(parts[i + 1], 10);
      }
      if (parts[i] === 'plb_adjustments' && !isNaN(parts[i + 1])) {
        plbIndex = parseInt(parts[i + 1], 10);
      }
    }

    if (plbIndex !== null) {
      entityType = 'plb_adjustment';
      entityPath = `plb_adjustments.${plbIndex}`;
    } else if (claimAdjustmentIndex !== null) {
      entityType = 'claim_adjustment';
      entityPath = `claims.${claimIndex}.claim_adjustments.${claimAdjustmentIndex}`;
    } else if (adjustmentIndex !== null) {
      entityType = 'service_line_adjustment';
      entityPath = `claims.${claimIndex}.service_lines.${serviceLineIndex}.adjustments.${adjustmentIndex}`;
    } else if (serviceLineIndex !== null) {
      entityType = 'service_line';
      entityPath = `claims.${claimIndex}.service_lines.${serviceLineIndex}`;
    } else if (claimIndex !== null) {
      entityType = 'claim';
      entityPath = `claims.${claimIndex}`;
    }

    return {
      entityType,
      entityPath,
      fieldName,
      claimIndex,
      serviceLineIndex,
      adjustmentIndex,
      claimAdjustmentIndex,
      plbIndex,
    };
  } catch (e) {
    return { entityType: null, entityPath: null, fieldName: null };
  }
};
let lastSavedTime = 0;

export function saveCache(getValues) {
  const now = Date.now();

  // only allow once every 500ms
  if (now - lastSavedTime < 500) return;

  lastSavedTime = now;

  const cache_data = getValues();
  // saveIndexedData("grid_data_cache", cache_data);
}

// Track edit meta on blur: set edited flags and edited_data with old_value and changed lists
export const trackFieldEditOnBlur = ({ name, oldValue, setValue, getValues }) => {
    // Parse the field name to determine the context
    const currentFieldValue = getValues(name);
    const pathParts = name.split('.');
    let editedPath = '';
    let editedDataPath = '';
    const isClaimExist = pathParts.includes('claims')
    // Determine the context based on the path structure
    if (isClaimExist) {
      const claimIndex = pathParts[pathParts.indexOf('claims') + 1];
      
      if (pathParts.includes('service_lines')) {
        const serviceLineIndex = pathParts[pathParts.indexOf('service_lines') + 1];
        
        if (pathParts.includes('adjustments')) {
          // Service line adjustment context
          const adjustmentIndex = pathParts[pathParts.indexOf('adjustments') + 1];
          editedPath = `claims.${claimIndex}.service_lines.${serviceLineIndex}.adjustments.${adjustmentIndex}.edited`;
          editedDataPath = `claims.${claimIndex}.service_lines.${serviceLineIndex}.adjustments.${adjustmentIndex}.edited_data`;
        } else {
          // Service line context
          editedPath = `claims.${claimIndex}.service_lines.${serviceLineIndex}.edited`;
          editedDataPath = `claims.${claimIndex}.service_lines.${serviceLineIndex}.edited_data`;
        }
      } else if (pathParts.includes('claim_adjustments')) {
        // Claim adjustment context
        const adjustmentIndex = pathParts[pathParts.indexOf('claim_adjustments') + 1];
        editedPath = `claims.${claimIndex}.claim_adjustments.${adjustmentIndex}.edited`;
        editedDataPath = `claims.${claimIndex}.claim_adjustments.${adjustmentIndex}.edited_data`;
      } else {
        // Claim context
        editedPath = `claims.${claimIndex}.edited`;
        editedDataPath = `claims.${claimIndex}.edited_data`;
      }
    } else if (pathParts.includes('plb_adjustments')) {
      // PLB adjustment context
      const adjustmentIndex = pathParts[pathParts.indexOf('plb_adjustments') + 1];
      editedPath = `plb_adjustments.${adjustmentIndex}.edited`;
      editedDataPath = `plb_adjustments.${adjustmentIndex}.edited_data`;
    }else if(name){
      editedPath = `edited`;
      editedDataPath = `edited_data`;
    }
    
    if (!editedPath || !editedDataPath) {
      console.warn('Could not determine edit context for field:', name);
      return;
    }
    
  // Get current values
  let currentEditedData = filterAndRemoveKeys(getValues(editedDataPath) || {});

  // Get the field name (last part of the path)
  const fieldName = pathParts[pathParts.length - 1];
  const isEdited = getValues(editedPath)
  // If not currently edited, set edited to true and store old value

  const isQAReview = window.location.pathname === NEW_QA_REVIEW;
  const isDataEntry = window.location.pathname === NEW_DATA_ENTRY;
  const fieldData = currentEditedData?.[fieldName] || {};
  // QA Review → check for missing "old_val"
  // Data Entry → check for existing "auto"

  const hasNoOldVal = !("old_val" in fieldData);
  const hasAuto = "auto" in fieldData;

  const FieldOldValue = currentEditedData?.[fieldName]?.old_val;
  const isSameAsOld = currentFieldValue == FieldOldValue;

  if (  (hasNoOldVal || hasAuto)) {
    setValue(editedPath, true,{ shouldValidate: false, shouldDirty: false });
      // Store old value in edited_data
      currentEditedData = {
        ...currentEditedData,
        [fieldName]: {
          ...currentEditedData[fieldName],
         ...(window.location.pathname===NEW_QA_REVIEW ? {"old_val": oldValue ||''} :{}),  //  {"old_val": oldValue ||null} null removed because of the  qa error is not gone while enter the old value  
         ...(window.location.pathname===NEW_QA_REVIEW ? {"error": true} :{}),
        }
      };
      delete currentEditedData?.[fieldName]?.['auto'];
      setValue(editedDataPath, currentEditedData,{ shouldValidate: false, shouldDirty: false });
    }
    else if(isSameAsOld){
        delete currentEditedData?.[fieldName]?.['old_val'];
        delete currentEditedData?.[fieldName]?.['error'];
        // delete currentEditedData?.[fieldName]?.['og_old_val'];
        if(Object.keys(currentEditedData?.[fieldName])?.length===0){
            delete currentEditedData?.[fieldName];
        }
        setValue(editedDataPath, currentEditedData,{ shouldValidate: false, shouldDirty: false });
        if(!!isEdited && hasQaError(currentEditedData)){
            setValue(editedPath, true,{ shouldValidate: false, shouldDirty: false });
        }else{
            setValue(editedPath, false,{ shouldValidate: false, shouldDirty: false });
        }
    }
    else if(!!isEdited){
        setValue(editedPath, true,{ shouldValidate: false, shouldDirty: false });
    }
    
    // Get the current field data
    const fieldEditedData = currentEditedData[fieldName] || {};
    
    // Check if auto key already exists
    if (fieldEditedData.hasOwnProperty('auto')) {
      // If auto key exists, add old_value and toggle auto value
      const updatedFieldData = {
        ...fieldEditedData,
        old_val: oldValue || "",
     
      };
       delete updatedFieldData['auto'];
      // Update edited_data
      const finalEditedData = {
        ...currentEditedData,
        [fieldName]: updatedFieldData
      };

      setValue(editedDataPath, finalEditedData,{ shouldValidate: false, shouldDirty: false });
    }
    saveCache(getValues)
};

const formatDate = (date) => {
  if (!date) return "";
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const yyyy = date.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
};

export const getNewPeriodDates = (serviceLines) => {
  try {
    const dates = serviceLines.filter(sl => sl.from_date || sl.to_date);
    if (dates.length === 0) return { period_start: "", period_end: "" };

    const fromDates = dates.map(sl => sl.from_date).filter(Boolean).map(d => new Date(d));
    const toDates = dates.map(sl => sl.to_date).filter(Boolean).map(d => new Date(d));

    const minDate = fromDates.length > 0 ? new Date(Math.min(...fromDates)) : null;
    const maxDate = toDates.length > 0 ? new Date(Math.max(...toDates)) : null;

    return {
      period_start: formatDate(minDate),
      period_end: formatDate(maxDate),
    };
  } catch (error) {
    return { period_start: "", period_end: "" };
  }
};

export const addDeletedIds = (key, claim_id,job_id, values, setValue) => {

  // Ensure both job_id and claim_id are present before proceeding
  if (!job_id || (!claim_id && claim_id !== 0)) {
    return;
  }

  // Get the existing data for the top-level 'key' (the object)
  const existingKeyData = values?.[key] || {};

  // Ensure the claim_id is an array for consistent handling
  const newClaimIds = Array.isArray(claim_id) ? claim_id : [claim_id];

  // Filter out any invalid claim_ids
  const validNewClaimIds = newClaimIds.filter(v => v !== '' && v !== null && v !== undefined);

  if (validNewClaimIds.length === 0) {
    return;
  }

  // Get the existing array of claim_ids for the current job_id
  const existingJobClaimIds = existingKeyData[job_id] || [];

  // Combine and deduplicate the claim_ids
  const updatedJobClaimIds = Array.from(new Set([...existingJobClaimIds, ...validNewClaimIds]));

  // Create a new object to avoid direct mutation and set the updated job_id entry
  const updatedKeyData = {
    ...existingKeyData,
    [job_id]: updatedJobClaimIds,
  };

  // Update the state with the new, merged data structure
  setValue(key, updatedKeyData);
};


// For even better performance with very large datasets:
export function processEditedClaimsUltraFast(claims,startClaimOrder=1) {
    const startTime = performance.now();
    const result = new Array(claims.length);
    
    for (let i = 0; i < claims.length; i++) {
        const claim = claims[i];
        let hasEdited = claim.edited === true;
        
        if (!hasEdited) {
            // Use for loops for maximum performance
            const serviceLines = claim.service_lines;
            if (serviceLines) {
                for (let j = 0; j < serviceLines.length && !hasEdited; j++) {
                    const sl = serviceLines[j];
                    if (sl.edited === true) {
                        hasEdited = true;
                    } else if (sl.adjustments) {
                        for (let k = 0; k < sl.adjustments.length; k++) {
                            if (sl.adjustments[k].edited === true) {
                                hasEdited = true;
                                break;
                            }
                        }
                    }
                }
            }
            
            if (!hasEdited) {
                const claimAdjustments = claim.claim_adjustments;
                if (claimAdjustments) {
                    for (let j = 0; j < claimAdjustments.length; j++) {
                        if (claimAdjustments[j].edited === true) {
                            hasEdited = true;
                            break;
                        }
                    }
                }
            }
        }
        
        if (hasEdited) {
            // Remove dbk_ keys and return full claim data with updated order
            const processedClaim = removeDbkKeys({ ...claim });
            processedClaim.order = startClaimOrder+i;
            result[i] = processedClaim;
        } else {
            result[i] = { claim_id: claim.claim_id, order: startClaimOrder+i };
        }
    }
    
    const endTime = performance.now();
    return result;
}

// Helper function to remove all dbk_ prefixed keys
function removeDbkKeys(obj) {
    const cleaned = {};
    
    for (const key in obj) {
        if (obj.hasOwnProperty(key) && !key.startsWith('dbk_')) {
            cleaned[key] = obj[key];
        }
    }
    
    return cleaned;
}

export function updateClaimAtIndex(claims, index, updates) {
  if (index < 0 || index >= claims.length) {
    throw new Error("Index out of bounds");
  }
  const updated = [...claims];
  updated[index] = {...updated[index], ...updates}; // merge updates
  return updated;
}

export function insertClaimAtIndex(claims, newClaim, index = claims.length) {
  const updated = [...claims];
  updated.splice(index, 0, newClaim);
  return updated;
}

export const validateSubmissionParams = (params) => {
  const { claimParams, headerParams, plbParams } = params;
    
  if (!claimParams?.job) {
    throw new Error('Job data is required for claim submission');
  }

  if (!Array.isArray(claimParams.claims)) {
    throw new Error('Claims must be an array');
  }

  // Add more validation as needed
};

export function manipulateTotalClaimPaidArray(existingArray, index, type, customData = {}) {
  const newArray = [...existingArray];
  if (type === 'create') {
    const defaultObject = {
      id: null,
      paid_amount: 0,
      ...customData
    };
    newArray.splice(index, 0, defaultObject);
    
  } else if (type === 'update') {
    const updatedObject = {
      id: null,
      paid_amount: 0,
      ...customData,
    };
    newArray[index] = updatedObject
    
  } else if (type === 'delete') {
    if (index >= 0 && index < newArray.length) {
      newArray.splice(index, 1);
    }
  }
  
  return newArray;
}


export const createFastFieldValidators = (contextValues = {}) => {
  const { jobData,isRarcCarcValidData = { CARC: [], RARC: [] } } = contextValues;
  
  // Pre-compiled regex patterns for better performance

  const disableCorresField1 = (field, claim,qdxTransaction) => {
    return grayOrdisableCorresField(field, claim, jobData, qdxTransaction)
  };

  const disableCorresField = (field,claim,qdxTransaction) => {
    return grayOrdisableCorresField(field, null, jobData, qdxTransaction)
  };

  const isAutomationNpiOrTin = (npi, tin) => {
    // Your existing logic for automation NPI/TIN validation
    return true; // placeholder
  };

  const isZero = (val) => {
    // Convert to number safely
    const num = Number(val);
    // Check NaN separately
    if (isNaN(num)) return false;
    // Treat 0, "0", "0.0", "0.00", etc. as zero
    return num === 0;
  };

  return {
    overall_page_from: (value, formData, context) => {
      if (formData.qdx_status === "INCOMPLETE") return null;
      
      const { totalPages } = context || {};
      const { overall_page_to } = formData || {};
      
      // Check if value is empty or zero
      if (!value || value <= 0) {
        return "Invalid Page Number";
      }
      
      // Check if exceeds total pages
      if (totalPages && value > totalPages) {
        return "Invalid Page Number";
      }
      
      // Check if from is greater than to
      if (overall_page_to && parseInt(value) > parseInt(overall_page_to)) {
        return "Invalid Page Number";
      }
      
      return null;
    },

    overall_page_to: (value, formData, context) => {
      if (formData.qdx_status === "INCOMPLETE") return null;
      
      const { totalPages } = context || {};
      const { overall_page_from } = formData || {};
      
      // Check if value is empty or zero
      if (!value || value <= 0) {
        return "Invalid Page Number";
      }
      
      // Check if exceeds total pages
      if (totalPages && value > totalPages) {
        return "Invalid Page Number";
      }
      
      // Check if from is greater than to
      if (overall_page_from && parseInt(overall_page_from) > parseInt(value)) {
        return "Invalid Page Number";
      }   return null;
    },
    // Root level validations
    payer_name: (value, formData, context) => {
      if (formData.qdx_status === "INCOMPLETE") return null;
      const { isSubJob } = context || {};
      if ((!value) || (!isSubJob && !value)) {
        return "Required";
      }
      return null;
    },

    payer_address: (value, formData, context) => {
      if (formData.qdx_status === "INCOMPLETE") return null;
      const { isSubJob } = context || {};
      if (!disableCorresField1('payer_address', null,formData?.transaction_type) && ((!value) || (!isSubJob && !value))) {
        return "Required";
      }
      return null;
    },

    payer_city: (value, formData, context) => {
      if (formData.qdx_status === "INCOMPLETE") return null;
      const { isSubJob } = context || {};
      if (!disableCorresField1('payer_city', null,formData?.transaction_type) && ((!value) || (!isSubJob && !value))) {
        return "Required";
      }
      return null;
    },

    payer_state: (value, formData, context) => {
      if (formData.qdx_status === "INCOMPLETE") return null;
      const { isSubJob, isFirstJob } = context || {};
      
      if (!disableCorresField1('payer_state', null,formData?.transaction_type) && ((!value) || (!isSubJob && !value))) {
        return "Required";
      }
      
      if (!isFirstJob && value && !patterns.stateAbbrev.test(value)) {
        return "Enter a valid State Abbreviation";
      }
      
      return null;
    },

    payer_zip: (value, formData, context) => {
      if (formData.qdx_status === "INCOMPLETE") return null;
      const { isSubJob } = context || {};
      
      if (!disableCorresField1('payer_zip', null,formData?.transaction_type) && ((!value) || (!isSubJob && !value))) {
        return "Required";
      }
      
      if (value && !patterns.zipCode.test(value)) {
        return "Enter a valid Zip code";
      }
      
      return null;
    },

    payee_npi: (value, formData, context) => {
      if (formData.qdx_status === "INCOMPLETE") return null;
      const { jobData } = context || {};
      
      if (!value) return null;
      
      if (!patterns.npi.test(value)) {
        return "Must be 10 digits";
      }
      
      // NPI mismatch check
      if (value && formData.is_valid_payee_npi) {
        const data837Npi = formData.data_837?.[formData.data_837?.length - 1]?.payee_npi;
        const isDefaultNpi = jobData?.default_payee?.default_npi === value;
        const hasValidation = formData.is_valid_payee_npi || formData.is_valid_tax_identification_number;
        
        if (data837Npi?.toUpperCase() !== value.toUpperCase() && 
            isAutomationNpiOrTin(value, formData.tax_identification_number) && 
            !isDefaultNpi && hasValidation) {
          return "NPI Missmatched";
        }
      }
      
      return null;
    },

    tax_identification_number: (value, formData, context) => {
      if (formData.qdx_status === "INCOMPLETE") return null;
      const { jobData } = context || {};
      
      if (!value) return null;
      
      if (!patterns.tin.test(value)) {
        return "Must be 9 digits";
      }
      
      // TIN mismatch check
      if (value && formData.is_valid_tax_identification_number) {
        const data837Tin = formData.data_837?.[formData.data_837?.length - 1]?.tax_identification_number;
        const isDefaultTin = jobData?.default_payee?.default_tin === value;
        const hasValidation = formData.is_valid_payee_npi || formData.is_valid_tax_identification_number;
        
        if (data837Tin?.toUpperCase() !== value.toUpperCase() && 
            isAutomationNpiOrTin(formData.payee_npi, value) && 
            !isDefaultTin && hasValidation) {
          return "Tax ID Missmatched";
        }
      }
      
      return null;
    },

    payee_zip: (value, formData, context) => {
      if (formData.qdx_status === "INCOMPLETE") return null;
      
      if (value && !patterns.zipCode.test(value)) {
        return "Enter a valid Zip code";
      }
      
      return null;
    },

    payee_state: (value, formData, context) => {
      if (formData.qdx_status === "INCOMPLETE") return null;
      const { isFirstJob } = context || {};
      
      if (!isFirstJob && value && !patterns.stateAbbrev.test(value)) {
        return "Enter a valid State Abbreviation";
      }
      
      return null;
    },

    credit_card_payment_method: (value, formData, context) => {
      if (formData.qdx_status === "INCOMPLETE") return null;
      const { jobData } = context || {};
      
      if (!value && 
          formData.payment_method === "VCP" && 
          formData.qdx_tranansaction_type === "PATIENT_PAY" && 
          jobData?.client_level_customization?.is_enabled_nextgen_patient_pay) {
        return "Required";
      }
      
      return null;
    },

    payment_source: (value, formData, context) => {
      if (formData.qdx_status === "INCOMPLETE") return null;
      const { jobData } = context || {};
      
      if (!value && 
          formData.qdx_tranansaction_type === "PATIENT_PAY" && 
          jobData?.client_level_customization?.is_enable_payment_source) {
        return "Required";
      }
      
      return null;
    },

    payment_method: (value, formData, context) => {
      if (formData.qdx_status === "INCOMPLETE") return null;
      const { isSubJob } = context || {};
      
      if ((!value) || (!isSubJob && !value)) {
        return "Select an option";
      }
      
      const checkAmount = parseFloat(formData.check_amount || 0);
      
      if (checkAmount === 0 && !["NON", "COR"].includes(value)) {
        return "Invalid Selection";
      }
      
      if (checkAmount > 0 && !["CHK", "ACH", "VCP", "OTH", "CCI"].includes(value)) {
        return "Invalid Selection";
      }
      
      if (value === "COR" && formData.transaction_type !== "CORRESPONDENCE_835") {
        return "Wrong Transaction Type";
      }
      
      if (value !== "COR" && formData.transaction_type === "CORRESPONDENCE_835") {
        return "Wrong Transaction Type";
      }
      
      const checkAmountFormatted = parseFloat(checkAmount).toFixed(2);
      if (checkAmountFormatted < parseFloat(0).toFixed(2)) {
        return "Negative value";
      }
      
      return null;
    },

    check_number: (value, formData, context) => {
      if (formData.qdx_status === "INCOMPLETE") return null;
      const { isSubJob } = context || {};
      
      if ((!value) || (!isSubJob && !value)) {
        return "Required";
      }
      
      return null;
    },

    check_amount: (value, formData, context) => {
      if (formData.qdx_status === "INCOMPLETE") return null;
      
      if (!value) {
        return "check amt cannot be null";
      }
      
      const checkAmount = parseFloat(value || 0);
      const checkAmountFormatted = parseFloat(checkAmount).toFixed(2);
      const paymentMethod = formData.payment_method;
      
      if (checkAmount < 0) {
        return "Negative value";
      }
      
      if (checkAmountFormatted === parseFloat(0).toFixed(2) && !["NON", "COR"].includes(paymentMethod)) {
        return "Invalid Selection";
      }
      
      if (value === "" && paymentMethod === "NON") {
        return "Invalid Selection";
      }
      
      if (checkAmountFormatted > parseFloat(0).toFixed(2) && !["CHK", "ACH", "VCP", "OTH", "CCI"].includes(paymentMethod)) {
        return "Invalid Selection";
      }
      
      return null;
    },

    aba_routing_number: (value, formData, context) => {
      if (formData.qdx_status === "INCOMPLETE") return null;
      const { jobData } = context || {};
      
      if (!jobData?.client_level_customization?.is_aba_routing_number) return null;
      
      if (!value && (formData.payment_method === "CHK" || formData.payment_method === "OTH" || !formData.payment_method)) {
        return "Invalid Selection";
      }
      
      if (value && !(formData.payment_method === "CHK" || formData.payment_method === "OTH")) {
        return "Invalid Selection";
      }
      
      return null;
    },

    payer_account_number: (value, formData, context) => {
      if (formData.qdx_status === "INCOMPLETE") return null;
      const { jobData } = context || {};
      
      if (!jobData?.client_level_customization?.is_payer_account_number) return null;
      
      if (!value && (formData.payment_method === "CHK" || formData.payment_method === "OTH" || !formData.payment_method)) {
        return "Invalid Selection";
      }
      
      if (value && !(formData.payment_method === "CHK" || formData.payment_method === "OTH")) {
        return "Invalid Selection";
      }
      
      return null;
    },

    remaining_balance: (value, formData, context) => {
      if (formData.qdx_status === "INCOMPLETE") return null;
      const { isSubJob } = context || {};
      
      if (!isSubJob && parseFloat(value || 0).toFixed(2) !== parseFloat(0).toFixed(2)) {
        return "Remaining balance must be zero";
      }
      
      return null;
    },

    check_page_number: (value, formData, context) => {
      const { totalPages, jobData } = context || {};

      if (formData.qdx_status === "INCOMPLETE") return null;

      if (disableCorresField("check_page_number",null,formData?.transaction_type)) return null;

      if (jobData?.client_level_customization?.ignore_check_page_validation) return null;

      if (!(formData.payment_method === "CHK" || formData.payment_method === "VCP")) return null;

      if (value === undefined || value === null || value === "") {
        return "Invalid check page number";
      }

      const num = Number(value);
      if ((totalPages && num > totalPages) || num <= 0) {
        return "Invalid check page number";
      }

      return null;
    },

    check_date: (value, formData, context) => {
      if (formData.qdx_status === "INCOMPLETE") return null;
      
      const cleanDate = value?.replace("__/__/____", "");
      if (!cleanDate) {
        return "Required";
      }
      
      if (!moment(cleanDate, "MM/DD/YYYY", true).isValid()) {
        return "Invalid date";
      }
      
      if (!moment(cleanDate, "MM/DD/YYYY", true).isAfter(minValidDate)) {
        return "Invalid date";
      }
      
      return null;
    },

    payer_page_from: (value, formData, context) => {
      if (formData.qdx_status === "INCOMPLETE") return null;
      const { totalPages, isPayerPage } = context || {};
      
      if (totalPages <= 0 || !isPayerPage) return null;
      
      if (value <= 0 || value === "" || value > totalPages || value > formData.payer_page_to) {
        return "Invalid Page Number";
      }
      
      return null;
    },

    payer_page_to: (value, formData, context) => {
      if (formData.qdx_status === "INCOMPLETE") return null;
      const { totalPages, isPayerPage } = context || {};
      
      if (totalPages <= 0 || !isPayerPage) return null;
      
      if (value <= 0 || value === "" || value > totalPages || formData.payer_page_from > value) {
        return "Invalid Page Number";
      }
      
      return null;
    },

    payee_page_from: (value, formData, context) => {
      if (formData.qdx_status === "INCOMPLETE") return null;
      const { totalPages, isPayeePage } = context || {};
      
      if (totalPages <= 0 || !isPayeePage) return null;
      
      if (value <= 0 || value === "" || value > totalPages || value > formData.payee_page_to) {
        return "Invalid Page Number";
      }
      
      return null;
    },

    payee_page_to: (value, formData, context) => {
      if (formData.qdx_status === "INCOMPLETE") return null;
      const { totalPages, isPayeePage } = context || {};
      
      if (totalPages <= 0 || !isPayeePage) return null;
      
      if (value <= 0 || value === "" || value > totalPages || formData.payee_page_from > value) {
        return "Invalid Page Number";
      }
      
      return null;
    },
    // PLB validation function - add this to your validators object
    validatePlbField: (fieldName, value, plbData, formData, context) => {
        if (formData?.qdx_status === "INCOMPLETE") return null;
        
        switch (fieldName) {
            case 'reason':
                if (!value) {
                    return "select a valid option";
                }
                return null;
                
            case 'plb_amt':
                if (!value || value === "" || value === null || 
                parseFloat(value).toFixed(2) === parseFloat(0).toFixed(2)) {
                    return "Select a valid option";
                }
                
                if (!patterns.amount.test(value)) {
                    return "Must be a valid amount";
                }
                return null;
                        
            case 'npi':
                if (!value) {
                    return "required";
                }
                
                if (value !== "" && !patterns.npi.test(value)) {
                return "Must be only digits";
        }
        return null;
        
        default:
            return null;
        }
    },
    // Nested field validators
    validateClaimField: (fieldName, value, claimData, formData, context) => {
      if (formData.qdx_status === "INCOMPLETE") return null;
      
      switch (fieldName) {
        case 'patient_account_number':
          return !value ? "Required" : null;
          
        case 'payer_claim_number':
          if (disableCorresField1('payer_claim_number', claimData,formData?.transaction_type)) return null;
          return !value ? "Required" : null;
          
        case 'status_code':
          return !value ? "Select an option" : null;
          
        case 'period_start':
        case 'period_end':
        const cleanDate = value?.replace("__/__/____", "");
        
        // Check if field is required and empty
        if (!cleanDate) return "Required";
        
        // Validate date format
        if (!moment(cleanDate, "MM/DD/YYYY", true).isValid()) {
            return "Invalid date";
        }
        
        // Additional validation for period_start - check against minimum valid date
        if (fieldName === 'period_start' && minValidDate) {
            if (!moment(cleanDate, "MM/DD/YYYY").isAfter(minValidDate)) {
            return "Invalid date";
            }
        }
        
        // Validate period_end is not before period_start
        if (fieldName === 'period_end' && claimData.period_start) {
            const cleanStartDate = claimData.period_start.replace("__/__/____", "");
            if (cleanStartDate && !moment(cleanDate, "MM/DD/YYYY").isSameOrAfter(cleanStartDate)) {
            return "Exceed the period_end date";
            }
        }
        
        return null;
          
        case 'claim_balance':
          return isZero(value)!= true  ? "Calculation Mistake" : null;

        case 'claim_billed':
          return isZero(claimData?.claim_balance)!= true  ? "Calculation Mistake" : null;
        

        case 'claim_allowed':
        const claimAllowed = parseFloat(value || 0).toFixed(2);
        const serviceLineAllowed = parseFloat(claimData?.sl_allowed || 0).toFixed(2);
        
        if (serviceLineAllowed !== "0.00" && value !== "" && claimAllowed !== serviceLineAllowed) {
            return "Amount Mismatch";
        }
        return null;

        case 'claim_deduct':
        const claimDeduct = parseFloat(value || 0).toFixed(2);
        const serviceLineDeduct = parseFloat(claimData?.sl_deduct || 0).toFixed(2);
        
        if (serviceLineDeduct !== "0.00" && value !== "" && claimDeduct !== serviceLineDeduct) {
            return "Amount Mismatch";
        }
        return null;

        case 'claim_coins':
        const claimCoins = parseFloat(value || 0).toFixed(2);
        const serviceLineCoins = parseFloat(claimData?.sl_coins || 0).toFixed(2);
        
        if (serviceLineCoins !== "0.00" && value !== "" && claimCoins !== serviceLineCoins) {
            return "Amount Mismatch";
        }
        return null;

        case 'claim_copay':
        const claimCopay = parseFloat(value || 0).toFixed(2);
        const serviceLineCopay = parseFloat(claimData?.sl_copay || 0).toFixed(2);
        
        if (serviceLineCopay !== "0.00" && value !== "" && claimCopay !== serviceLineCopay) {
            return "Amount Mismatch";
        }
        return null;

        case 'claim_cob':
        const claimCob = parseFloat(value || 0).toFixed(2);
        const serviceLineCob = parseFloat(claimData?.sl_cob || 0).toFixed(2);
        
        if (serviceLineCob !== "0.00" && value !== "" && claimCob !== serviceLineCob) {
            return "Amount Mismatch";
        }
        return null;

        case 'claim_paid':
        const claimPaid = parseFloat(value || 0).toFixed(2);
        const serviceLinePaid = parseFloat(claimData?.sl_paid || 0).toFixed(2);
        
        if (serviceLinePaid !== "0.00" && value !== "" && claimPaid !== serviceLinePaid) {
            return "Amount Mismatch";
        }
        return null;

        case 'rendering_provider_identifier_code':
          if (!claimData.rendering_provider) return null;
          if (disableCorresField1('rendering_provider_identifier_code', claimData,formData?.transaction_type)) return null;
          if (!value) return "required";
          return !patterns.npi.test(value) && !patterns.tin.test(value) ? "Must be only digits" : null;

        case "page_from": {
          const root = formData; // assuming formData contains qdx_status etc.
          const { qdx_status } = root || {};
          const { page_to } = claimData || {};
          const { totalPages, jobData } = context || {};

          if (qdx_status === "INCOMPLETE") return null;

          if (!value || value <= 0 || value > totalPages) return "Invalid Page Number";

          if (page_to && value > Number(page_to)) return "Invalid Page Number";

          // ✅ large batch job checks
          if (jobData?.is_large_batch_job) {
            const isHeaderRange = jobData?.header_range?.some(i => Number(i) === value);
            const isFooterRange = jobData?.footer_range?.some(i => Number(i) === value);

            if (jobData?.is_last_sub_job && isHeaderRange) return "Invalid Page Number";

            if (
              !jobData?.is_last_sub_job &&
              !jobData?.is_first_sub_job &&
              isFooterRange
            )
              return "Invalid Page Number";
          }

          return null;
        }

        case "page_to": {
          const root = formData;
          const { qdx_status } = root || {};
          const { page_from } = claimData || {};
          const { totalPages, jobData } = context || {};
          

          if (qdx_status === "INCOMPLETE") return null;

          if (!value || value <= 0 || value > totalPages) return "Invalid Page Number";

          if (page_from && Number(page_from) > value) return "Invalid Page Number";

          // ✅ large batch job checks
          if (jobData?.is_large_batch_job) {
            const isHeaderRange = jobData?.header_range?.some(i => Number(i) === value);
            const isFooterRange = jobData?.footer_range?.some(i => Number(i) === value);

            if (jobData?.is_last_sub_job && isHeaderRange) return "Invalid Page Number";

            if (
              !jobData?.is_last_sub_job &&
              !jobData?.is_first_sub_job &&
              isFooterRange
            )
              return "Invalid Page Number";
          }

          return null;
        }

        default:
          return null;
      }
    },

    validateServiceLineField: (fieldName, value, serviceLineData, claimData, formData, context) => {
    // Skip validation if status is INCOMPLETE
    if (formData?.qdx_status === "INCOMPLETE") return null;
    
    switch (fieldName) {
        case 'procedure_type':
        // Check if procedure_type is empty, undefined, or invalid
        if (value === "" || value === undefined || !value) {
            return "Invalid option";
        }
        return null;
        
        case 'code':
        // Check if field is disabled/grayed out using your coseGrayField logic
        const codeGrayField = context?.coseGrayField || !disableCorresField1('code', claimData,formData?.transaction_type);
        if (!codeGrayField) return null;
        
        if (!value) return "Required";
        return !patterns.code.test(value) ? "Enter a Valid Code" : null;
        
        case 'from_date':
        const cleanFromDate = value?.replace("__/__/____", "");
        if (!cleanFromDate || cleanFromDate === "") return "Required";
        
        const isValidFromDate = moment(cleanFromDate, "MM/DD/YYYY", true).isValid() && 
                                moment(cleanFromDate, "MM/DD/YYYY", true).isAfter(minValidDate || moment("1900-01-01"));
        if (!isValidFromDate) return "Invalid date";
        
        // Check if to_date exists and from_date exceeds it
        if (serviceLineData.to_date) {
            const cleanToDate = serviceLineData.to_date?.replace("__/__/____", "");
            if (cleanToDate && moment(cleanToDate, "MM/DD/YYYY").isValid()) {
            if (!moment(cleanToDate, "MM/DD/YYYY").isSameOrAfter(cleanFromDate)) {
                return "Exceed the from date";
            }
            }
        }
        return null;
        
        case 'to_date':
        const cleanToDate = value?.replace("__/__/____", "");
        if (!cleanToDate || cleanToDate === "") return "Required";
        
        const isValidToDate = moment(cleanToDate, "MM/DD/YYYY", true).isValid() && 
                                moment(cleanToDate, "MM/DD/YYYY", true).isAfter(minValidDate || moment("1900-01-01"));
        if (!isValidToDate) return "Invalid date";
        
        // Check if from_date exists and to_date is before it
        if (serviceLineData.from_date) {
            const cleanFromDateForTo = serviceLineData.from_date?.replace("__/__/____", "");
            if (cleanFromDateForTo && moment(cleanFromDateForTo, "MM/DD/YYYY").isValid()) {
            if (!moment(cleanToDate, "MM/DD/YYYY").isSameOrAfter(cleanFromDateForTo)) {
                return "Exceed the from date";
            }
            }
        }
        return null;
        
        case 'modifier1':
        case 'modifier2':
        case 'modifier3':
        case 'modifier4':
        if (!value) return null; // Optional fields
        return !patterns.modifier.test(value) ? `Enter a Valid ${fieldName}` : null;
        
        case 'rev_code':
        if (!value) return null; // Optional field
        return !patterns.revCode.test(value) ? "Enter a Valid rev_code" : null;
        
        // Financial fields - check for balance mismatch
        case 'billed':
        case 'discount':
        case 'allowed':
        case 'deduct':
        case 'coins':
        case 'copay':
        case 'cob':
        case 'paid':
        // Check if balance calculation is off (not equal to 0.00)
        const balance = serviceLineData?.balance;
        // const isValidGray = disableCorresField1('payer_address',jobData,transaction_type)
        if (balance !== undefined && balance !== null) {
            const balanceFloat = parseFloat(balance).toFixed(2);
            const zeroFloat = parseFloat(0).toFixed(2);
            if (balanceFloat !== zeroFloat) {
            return "Balance mismatch";
            }
        }
        return null;
        
        default:
        return null;
    }
    },

    // Helper function for adjustment validation (based on your adjustment validation logic)
    validateAdjustmentField: (fieldName, value, adjustmentData, serviceLineData, claimData, formData, context) => {
    const isIncomplete = formData?.qdx_status === "INCOMPLETE";
    
    switch (fieldName) {
        case 'group_code':
        // Required if adjustment amount is not 0 and field is not disabled
        const adjustmentAmount = parseFloat(adjustmentData?.amount || 0);
        const isFieldDisabled = disableCorresField1('group_code', claimData,formData?.transaction_type);
        
        if (!value && adjustmentAmount !== 0 && !isFieldDisabled) {
            return "Required";
        }
        return null;
        
        case 'reason_code':
        if (isIncomplete) return null;
        
        // Required if group_code is provided
        if (!isIncomplete && adjustmentData?.group_code && adjustmentData.group_code !== '' && !value) {
            return "Required";
        }
        
        // Validate format if value exists
        if (value && !patterns.reasonCode.test(value)) {
            return "Maximum 3 digits";
        }
        
        // Validate against CARC codes if available
        if (value && context?.isRarcCarcValidData?.CARC && 
            !context.isRarcCarcValidData.CARC.includes(value.toUpperCase()) && 
            adjustmentData?.is_invalid_reason_code) {
            return "Invalid reason code";
        }
        
        return null;
        
        case 'rmk':
        if (isIncomplete) return null;
        
        if (value) {
            // Validate format and require at least one number
            if (!patterns.rmk.test(value) || !/[0-9]/.test(value)) {
            return "Maximum 5 digits";
            }
            
            // Validate against RARC codes if available
            if (context?.isRarcCarcValidData?.RARC && 
                !context.isRarcCarcValidData.RARC.includes(value.toUpperCase()) && 
                adjustmentData?.is_invalid_rmk) {
            return "Invalid rmk";
            }
        }
        
        return null;
        
        case 'amount':
        // Sequestration validation for reason code 253 (commented out in original)
        // This would check if adjustment amount exceeds 2% of allowed amount
        if (adjustmentData?.reason_code === '253' && 
            serviceLineData?.allowed && 
            value &&
            context?.sequestrationServicelineAdjustmentValidation?.(serviceLineData, adjustmentData)) {
          return 'Amount > 2% sequestration validation';
        }
        return null;
        
        default:
        return null;
    }
    }
  };
};

export const createSingleFieldValidator = (contextValues = {}) => {
  const validators = createFastFieldValidators(contextValues);

  return (fieldPath, value, formData, context = {}) => {
    // Parse field path like "claims[0].service_lines[1].code"
    const pathParts = fieldPath.split(/[.\[\]]+/).filter(Boolean);
    
    if (pathParts.length === 1) {
      // Root level field
      const validator = validators[pathParts[0]];
      return validator ? validator(value, formData, context) : null;
    }
    
    // Handle nested paths
    const [rootField, ...restPath] = pathParts;
    if(rootField === "plb_adjustments"){
      const plbIndex = parseInt(restPath[0]);;//parseInt(restPath[0]);
      const plbData = formData?.plb_adjustments?.[plbIndex];
      
      if (!plbData) return null;
      if (restPath.length === 2) {
        return validators.validatePlbField(restPath[1], value, plbData, formData, context);
      }
    }
    else if (rootField === 'claims') {
      const claimIndex = 0;//parseInt(restPath[0]);
      const claimData = formData.claims?.[claimIndex];
      
      if (!claimData) return null;
      
      if (restPath.length === 2) {
        // Claim level field
        return validators.validateClaimField(restPath[1], value, claimData, formData, context);
      }

      if (restPath[1] === 'service_lines') {
        const serviceLineIndex = parseInt(restPath[2]);
        const serviceLineData = claimData.service_lines?.[serviceLineIndex];
        
        if (!serviceLineData) return null;
        
        if (restPath.length === 4) {
          // Service line field
          return validators.validateServiceLineField(restPath[3], value, serviceLineData, claimData, formData, context);
        }
        
        if (restPath[3] === 'adjustments') {
          const adjustmentIndex = parseInt(restPath[4]);
          const adjustmentData = serviceLineData.adjustments?.[adjustmentIndex];
          
          if (!adjustmentData) return null;
          
          if (restPath.length === 6) {
            // Adjustment field
            return validators.validateAdjustmentField(restPath[5], value, adjustmentData, serviceLineData, claimData, formData, context);
          }
        }
      }else if (restPath[1] === 'claim_adjustments') {
          const adjustmentIndex = parseInt(restPath[2]);
          const adjustmentData = claimData.claim_adjustments?.[adjustmentIndex];
          
          if (!adjustmentData) return null;
          
          if (restPath.length === 4) {
            // Adjustment field
            return validators.validateAdjustmentField(restPath[3], value, adjustmentData, null, claimData, formData, context);
          }
        }
    }
    
    return null;
  };
};

// 5. Integration with react-hook-form trigger
export const validateSpecificFields = async (fieldPaths,formData,setError,clearErrors,contextValues = {}) => {
  const validator = createSingleFieldValidator(contextValues);
  
  const promises = fieldPaths?.map(async (fieldPath) => {
    const value = getNestedValue(formData, fieldPath);
    const error = validator(fieldPath, value, formData, contextValues);

    if (error) {
      setError(fieldPath, { message: error });
      return false;
    } else {
      clearErrors(fieldPath);
      return true;
    }
  });
  
  const results = await Promise.all(promises);
  return results.every(Boolean);
};

export const validateRarcCarcCodeRHF = async ({
  isRarcCarcValidData,
  setIsRarcCarcValidData,
  qdx_status,
  search1,
  type,
  name, // e.g. claims.[0].service_lines.[0].adjustments[0].reason_code
  setValue,
  is_papercode = false,
  setError,
  clearErrors
}) => {
  if (qdx_status === "INCOMPLETE") return;

  const search = search1?.toUpperCase();
  if (!search?.length) return;

  // replace reason_code with either is_invalid_reason_code or is_invalid_rmk
  const invalidFieldName = name.replace(
    /[^.]+$/, //replace after last dot
    type === "CARC" ? "is_invalid_reason_code" : "is_invalid_rmk"
  )

  if (isRarcCarcValidData[type]?.includes(search)) {
    setValue(invalidFieldName, "", { shouldValidate: true, shouldDirty: true });
    return;
  }

  const isValidCARC = (value) => /^[a-zA-Z0-9]{0,3}$/.test(value);
  const isValidRARC = (value) =>
    /^[A-Za-z][A-Za-z0-9]{0,4}$/.test(value) && /[0-9]/.test(value);

  const shouldCallApi =
    (type === "CARC" && isValidCARC(search)) ||
    (type === "RARC" && isValidRARC(search));

  if (!shouldCallApi) return;

  // setValue(invalidFieldName, `Invalid ${type}`, {
  //   shouldValidate: true,
  //   shouldDirty: true,
  // });

  getValidatecARCaNDrARC(search, type)((response) => {
    if (response?.status_code === 200) {
      if (response?.status) {

        setValue(invalidFieldName, "");
        // clearErrors(name);
        setError(name, {});

        setIsRarcCarcValidData((prev) => {
          if (prev[type].includes(search)) return prev;
          return { ...prev, [type]: [...prev[type], search] };
        });
      } else {
        setValue(invalidFieldName, `Invalid ${type}`);
        setError(name, { type: "manual", message: `Invalid ${type}` });
      }
    }
  });
};




//=================| this will return the first error in claim  | ======================== 
export function validateClaimOneByOne(claim, formData, context) { 
  const validators = createFastFieldValidators(context);
  const errors = {};

  // ✅ Claim-level fields
  for (const [fieldName, value] of Object.entries(claim)) {
    const err = validators.validateClaimField(fieldName, value, claim, formData, context);
    if (err) {
      errors[fieldName] = err;
      return errors; // stop immediately
    }
  }

  // ✅ Service lines
  for (let i = 0; i < (claim.service_lines?.length || 0); i++) {
    const serviceLine = claim.service_lines[i];
    const slErrors = {};

    // Service line fields
    for (const [fieldName, value] of Object.entries(serviceLine)) {
      const err = validators.validateServiceLineField(
        fieldName,
        value,
        serviceLine,
        claim.claim_fields,
        formData,
        context
      );
      if (err) {
        slErrors[fieldName] = err;
        errors.serviceLines = { [i]: slErrors };
        return errors; // stop immediately
      }
    }

    // Adjustments
    for (let j = 0; j < (serviceLine.adjustments?.length || 0); j++) {
      const adjustment = serviceLine.adjustments[j];
      const adjErrors = {};

      for (const [fieldName, value] of Object.entries(adjustment)) {
        const err = validators.validateAdjustmentField(
          fieldName,
          value,
          adjustment,
          serviceLine,
          claim,
          formData,
          context
        );
        if (err) {
          adjErrors[fieldName] = err;
          errors.serviceLines = { [i]: { adjustments: { [j]: adjErrors } } };
          return errors; // stop immediately
        }
      }
    }
  }

  return errors;
}
export const validateClaimLiteOneByOne = (claim, formData, context) => {
  const claimErrors = {};

  // Validate claim-level fields
  const claimFields = ["patient_account_number", "page_from", "page_to"];
  claimFields.forEach((field) => {
    const error = validateLiteClaim(claim, field, context);
    if (error) {
      Object.assign(claimErrors, error);
    }
  });

  // Validate service lines
  if (claim.service_lines && Array.isArray(claim.service_lines)) {
    claimErrors.service_lines = claim.service_lines.map((line) => {
      const lineErrors = {};
      const serviceLineFields = ["billed", "paid", "period_start", "period_end"];
      serviceLineFields.forEach((field) => {
        const error = validateLiteServiceLine(line, field, context);
        if (error) {
          Object.assign(lineErrors, error);
        }
      });
      return lineErrors;
    });
  }

  // Filter out empty error objects
  const cleanedErrors = JSON.parse(
    JSON.stringify(claimErrors, (key, value) =>
      value && typeof value === "object" && Object.keys(value).length === 0 ? undefined : value
    )
  );

  // Check and remove service_lines key if all its elements are null
  if (cleanedErrors.service_lines && cleanedErrors.service_lines.every(line => line === null)) {
    delete cleanedErrors.service_lines;
  }

  return cleanedErrors || {};
};

export const validateClaimCorresOneByOne = (claim, formData, context) => {
  const claimErrors = {};

  // Validate claim-level fields
  const claimFields = ["period_start", "period_end", "page_from", "page_to", "patient_account_number", "patient_first_name", "patient_middle_name", "patient_last_name", "billed"];
  claimFields.forEach((field) => {
    const error = validateCorresClaim(claim, field, context,formData);
    if (error) {
      Object.assign(claimErrors, error);
    }
  });
  if(Object.keys(claimErrors).length === 0){
      return {};
  }else{
      // Filter out empty error objects
      const cleanedErrors = JSON.parse(
        JSON.stringify(claimErrors, (key, value) =>
          value && typeof value === "object" && Object.keys(value).length === 0 ? undefined : value
        )
      );
    
      return cleanedErrors || {};
  } 
};

export const markAllEditedTrue = (data) => {
  if (Array.isArray(data)) {
    return data.map(item => markAllEditedTrue(item));
  }

  if (typeof data === "object" && data !== null) {
    const updated = {};
    for (const key in data) {
      if (key === "edited") {
        updated[key] = true;
      } else {
        updated[key] = markAllEditedTrue(data[key]);
      }
    }
    return updated;
  }

  return data;
};
export const handlePatientAccountTab = ({ e, jobData,index,isAutomation }) => {
  const isSubJob = jobData?.is_sub_job
  const isFirstJob = jobData?.is_first_sub_job

  const pathname = window.location.pathname
  if (!(!isSubJob && isFirstJob || isSubJob && !isFirstJob) && index == 0 && !e.shiftKey && e.key == 'Tab' && pathname == NEW_DATA_ENTRY && !isAutomation) { //DATA_ENTRY
    e.preventDefault();
    const claimAccountNo = document.querySelector(`[name="payer_name"]`)
    if (claimAccountNo) {
      claimAccountNo.focus();
    }
  }

}

export function stopTabOnLastButton(containerSelector) {
  const container = document.querySelector(containerSelector);
  if (!container) return;

  const getButtons = () =>
    Array.from(
      container.querySelectorAll("button:not([disabled])")
    );

  const handleKeyDown = (e) => {
    if (e.key !== "Tab" || e.shiftKey) return;

    const buttons = getButtons();
    if (!buttons.length) return;

    const last = buttons[buttons.length - 1];

    if (document.activeElement === last) {
      e.preventDefault(); // stop focus moving out
    }
  };

  container.addEventListener("keydown", handleKeyDown);
  return () => container.removeEventListener("keydown", handleKeyDown);
}
 
export const allowNumberOnlly =(e)=>{
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
        return false
    }
    return true
}

export const isQdxTransactionType = (transaction_type)=>{
    return ["PAYMENT835","PATIENT_PAY_835","CORRESPONDENCE_835"].includes(transaction_type)
}
export const getQdxTransactionType = (transaction_type)=>{
    if(transaction_type==="PAYMENT835")return"PAYMENT835"
    else if(transaction_type==="PATIENT_PAY_835")return"PATIENT_PAY"
    else if(transaction_type==="CORRESPONDENCE_835")return"CORRESPONDENCE"
}

 // Utility to create edited_data for any object, excluding keys

 // Utility to create edited_data for any object, excluding keys
export const createEditedData = (source, keysToExclude = []) => {
  if (!source) return {};
  return Object.fromEntries(
    Object.entries(source)
      .filter(([key]) => !keysToExclude.includes(key))
      .map(([key, value]) => [key, { old_val: null, error: true }]) //null means all time qa error
  );
};

// Keys to exclude at different levels
const serviceLineKeysToExclude = ["service_line_id"];
const adjustmentKeysToExclude = ["adjustment_id"];

export const addEditedDataToServiceLine = (serviceLine) => {
  const copiedServiceLine = { ...serviceLine };

  // Add edited_data at service line level
  copiedServiceLine.edited_data = createEditedData(copiedServiceLine, serviceLineKeysToExclude);

  // Add edited_data at adjustment level
  copiedServiceLine.adjustments = copiedServiceLine.adjustments?.map((adj) => ({
    ...adj,
    edited_data: createEditedData(adj, adjustmentKeysToExclude),
  })) || [];

  return copiedServiceLine;
};

// Usage in your callback



export const getErrorMessage = (errors) => {
  if (!errors || typeof errors !== "object") return "Unknown error";

  const firstKey = Object.keys(errors)[0];
  if (!firstKey) return "Unknown error";

  const val = errors[firstKey];
  return Array.isArray(val) ? val[0] : val;
};


//  =======================|  this is for the create editedData for the ~~~~| LOAD ORIGINAL |~~~~~   |================

export const buildEditedClaim = (oldClaim, newClaim) => {
  const mergeEditedData = (oldEdited = {}, colorData = {}, oldObj = {}, newObj = {}) => {
    const merged = { ...oldEdited };

    Object.keys(colorData).forEach((key) => {
      if (colorData[key]) {
        merged[key] = {
          ...(merged[key] || {}), //  preserve everything inside
          auto_edi: newObj[key] ?? null, // add/replace edi only
        };
      }
    });

    return merged;
  };

  // Claim-level
  const editedClaim = {
    ...newClaim,
    edited_data: mergeEditedData(oldClaim?.edited_data, newClaim?.color_data, oldClaim, newClaim),
    service_lines: newClaim?.service_lines?.map((newLine, i) => {
      const oldLine = oldClaim.service_lines?.[i] || {};
      return {
        ...newLine,
        edited_data: mergeEditedData(oldLine?.edited_data, newLine?.color_data, oldLine, newLine),
      };
    }),
  };

  return editedClaim;
};



// ________________|  this function is for ~~~~| Revert 837 |~~~~~  for  delete all auto edi key form the cliam and servicelien   and adj wise  |_______________

export const removeEdiFromClaim = (claim) => {

  // Deep clone to avoid mutation
  const cleanedClaim = JSON.parse(JSON.stringify(claim));

  // --- Claim-level ---
  if (cleanedClaim?.edited_data) {
    Object.keys(cleanedClaim?.edited_data).forEach((key) => {
      if ("auto_edi" in cleanedClaim?.edited_data[key]) {
        delete cleanedClaim?.edited_data[key].auto_edi;
      }
    });
  }

  // --- Service-line-level ---
  if (Array.isArray(cleanedClaim.service_lines)) {
    cleanedClaim.service_lines = cleanedClaim.service_lines.map((line) => {
      if (line?.edited_data) {
        Object.keys(line?.edited_data).forEach((key) => {
          if ("edi" in line?.edited_data?.[key]) {
            delete line?.edited_data?.[key]?.edi;
          }
        });
      }

      // --- Adjustment-level ---
      if (Array.isArray(line.adjustments)) {
        line.adjustments = line.adjustments.map((adj) => {
          if (adj?.edited_data) {
            Object.keys(adj?.edited_data).forEach((key) => {
              if ("edi" in adj?.edited_data?.[key]) {
                delete adj?.edited_data?.[key]?.edi;
              }
            });
          }
          return adj;
        });
      }

      return line;
    });
  }

  return cleanedClaim;
};


// --------------------------| this function is for merge claims  |--------------------------

export const mergeTwoClaims = (claim1, claim2) => {
 

  const mergedClaim = { ...claim1 };

  // --- Claim-level ---
  Object.keys(claim2).forEach((key) => {
    if (key === "service_lines" || key === "adjustments" || key === "claim_adjustments") return;

    const val1 = claim1[key];
    const val2 = claim2[key];

    if (val2 !== undefined && val2 !== null && val2 !== "") {
      mergedClaim[key] = val2;
      mergedClaim.edited_data = mergedClaim.edited_data || {};
      mergedClaim.edited_data[key] = claim2.edited_data?.[key] || {};
    } else if (val1 !== undefined && val1 !== null && val1 !== "") {
      mergedClaim[key] = val1;
      mergedClaim.edited_data = mergedClaim.edited_data || {};
      mergedClaim.edited_data[key] = claim1.edited_data?.[key] || {};
    }
  });

  // --- Service-lines ---
  mergedClaim.service_lines = (claim2.service_lines || []).map((line2, i) => {
    const line1 = claim1.service_lines?.[i] || {};
    const mergedLine = { ...line1 };

    Object.keys(line2).forEach((key) => {
      if (key === "adjustments") return;

      const val1 = line1[key];
      const val2 = line2[key];

      if (val2 !== undefined && val2 !== null && val2 !== "") {
        mergedLine[key] = val2;
        mergedLine.edited_data = mergedLine.edited_data || {};
        mergedLine.edited_data[key] = line2.edited_data?.[key] || {};
      } else if (val1 !== undefined && val1 !== null && val1 !== "") {
        mergedLine[key] = val1;
        mergedLine.edited_data = mergedLine.edited_data || {};
        mergedLine.edited_data[key] = line1.edited_data?.[key] || {};
      }
    });

    // --- Adjustments inside service-line ---
    mergedLine.adjustments = (line2.adjustments || []).map((adj2, j) => {
      const adj1 = line1.adjustments?.[j] || {};
      const mergedAdj = { ...adj1 };

      Object.keys(adj2).forEach((key) => {
        const val1 = adj1[key];
        const val2 = adj2[key];

        if (val2 !== undefined && val2 !== null && val2 !== "") {
          mergedAdj[key] = val2;
          mergedAdj.edited_data = mergedAdj.edited_data || {};
          mergedAdj.edited_data[key] = adj2.edited_data?.[key] || {};
        } else if (val1 !== undefined && val1 !== null && val1 !== "") {
          mergedAdj[key] = val1;
          mergedAdj.edited_data = mergedAdj.edited_data || {};
          mergedAdj.edited_data[key] = adj1.edited_data?.[key] || {};
        }
      });

      return mergedAdj;
    });

    return mergedLine;
  });

  // --- Claim-level adjustments ---
  mergedClaim.claim_adjustments = (claim2.claim_adjustments || []).map((adj2, i) => {
    const adj1 = claim1.claim_adjustments?.[i] || {};
    const mergedAdj = { ...adj1 };

    Object.keys(adj2).forEach((key) => {
      const val1 = adj1[key];
      const val2 = adj2[key];

      if (val2 !== undefined && val2 !== null && val2 !== "") {
        mergedAdj[key] = val2;
        mergedAdj.edited_data = mergedAdj.edited_data || {};
        mergedAdj.edited_data[key] = adj2.edited_data?.[key] || {};
      } else if (val1 !== undefined && val1 !== null && val1 !== "") {
        mergedAdj[key] = val1;
        mergedAdj.edited_data = mergedAdj.edited_data || {};
        mergedAdj.edited_data[key] = adj1.edited_data?.[key] || {};
      }
    });

    return mergedAdj;
  });

  return mergedClaim;
};

export function getTaskType() {
  if (window.location.pathname === NEW_DATA_ENTRY) {
    return '1';
  } else if (window.location.pathname === NEW_QA_REVIEW) {
    return '2';
  } else if (window.location.pathname.startsWith(NEW_EDIT_WORK)) {
    return '2';
  } else {
    // Return a default value or handle other cases as needed
    return null;
  }
}export const createEditedData_formArray = (keys) => {
  return keys.reduce((acc, key) => {
    acc[key] = { old_val: null };
    return acc;
  }, {});
};
